import { Container, Grid, Stack } from '@mui/material';
import { useOrgId } from 'components/pages/org/outlet';
import { NavList, NavListItem } from 'components/ui/nav-list';
import { PageContent, PageTitle } from 'components/ui/page';
import { Outlet } from 'react-router-dom';

export const OrgAccountOutlet = () => {
	return (
		<>
			<PageTitle title="Account Settings" />
			<PageContent>
				<Container>
					<Grid container spacing={4}>
						<Grid item xs={12} md={3}>
							<NavList title="Account Settings" sticky>
								<Stack
									spacing={{ xs: 2, md: 'unset' }}
									direction={{ xs: 'row', md: 'column' }}>
									<NavListItem text="Account Information" end to="./" />
								</Stack>
							</NavList>
						</Grid>
						<Grid item xs={12} md={9}>
							<Outlet context={useOrgId()} />
						</Grid>
					</Grid>
				</Container>
			</PageContent>
		</>
	);
};
